import { Controller } from 'stimulus';

class TransportController extends Controller {
  toggleMoreInformation(e) {
    if (!this.hasInformationTarget) {
      return;
    }

    if (e.target.value === 'Ja') {
      this.informationTarget.style.display = 'block';
    }

    if (e.target.value === 'Nee') {
      this.informationTarget.style.display = 'none';
    }
  }
}

TransportController.targets = [
  'information',
];

export default TransportController;
